import { Filter, FilterQuery } from '../models/Filter';

export type PlannedTimeRange = Array<string | Date>;

export const getPlannedTimeQuery = (filter: Filter): FilterQuery | undefined =>
  filter.queries.find((query) => query.on === 'plannedTime');

// Both bounds are normalized to the local day so the window is symmetric
// regardless of any time component the picker may carry.
const startOfDay = (date: string | Date): Date => {
  const result = new Date(date);
  result.setHours(0, 0, 0, 0);
  return result;
};

const endOfDay = (date: string | Date): Date => {
  const result = new Date(date);
  result.setHours(23, 59, 59, 999);
  return result;
};

// The plannedTime filter scopes the list on the backend via from/to (ISO-8601) query params.
export const getPlannedTimeRange = (filter: Filter): { from?: string; to?: string } => {
  const value = getPlannedTimeQuery(filter)?.value;
  const range: PlannedTimeRange = Array.isArray(value) ? value : [];
  const [start, end] = range;

  return {
    from: start ? startOfDay(start).toISOString() : undefined,
    to: end ? endOfDay(end).toISOString() : undefined
  };
};
